import React, { useEffect, useState } from "react";
import NuDate from "../../../../Components/Utils/NuDate";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { Link, useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../../../Services/axiosCommon";
import { BackButton, EditButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import DownArrow from "../../../../Components/Icons/DownArrow";
import { Button, Input, notification, Popover, Progress, Select } from "antd";
import moment from "moment";
import DecryptData from "../../../../Components/Utils/Decrypt";
import EditComments from "./EditComments";
import ViewFiles from "./viewFiles";
import CustomAttachmentUpload from "../../../../Components/Utils/CustomFileUpload";
import { useFormik } from "formik";
import * as yup from "yup";
import { NuInput } from "../../../../Components/Utils/Input";
import NuAvatarGroupWithOutLink from "../../../../Layouts/NuAvatarGroupWithoutLink";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import FilesView from "../../../../Components/Utils/FilesView";
import { GetAccess } from "../../../../Components/Utils/roles";
import dayjs from "dayjs";
import { CalendarDays, User2 } from "lucide-react";

function ViewnewTask({isLoading}) {
  const { alltasksViewId } = useParams();
  const location = useLocation();
  const Data = location?.state?.data;

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const [data, setData] = useState([]);

  const from = location.state?.from || -1;

  console.log("from", from);

  function getView() {
    axiosInstance
      .get(`/tasks/${alltasksViewId}`)
      .then((res) => {
        const task = res.data?.data;
        setData(task);
        setAssignee(task.assignedTo?.map((user) => user.id) || []);
        setCopyTo(task.copyTo?.map((user) => user.id) || []);
      })
      .catch((err) => console.log("err", err));
  }

  useEffect(
    (alltasksViewId) => {
      // if (!cdata) {
      getView();
      // }
    },
    [alltasksViewId]
  );
  const [createNew, setCreateNew] = useState({
    // projectId: "",
    // titleId: "",
    // taskName: "",
    // assignedTo: [],
    // copyTo: [],
    // priority: "",
    // severity: "",
    // taskStatus: "",
    // // comment: "",
    // startDate: "",
    // endDate: "",
    // reminderDate: "",
    // reminderTime: "",
    // attachment: "",
    // reAssignedTo: [],
    // taskTeam: "",
    // noOFWeeks: "",
    // noOFDays: "",
  });

  const [api, contextHolder] = notification.useNotification();
  const [teamId, setTeamId] = useState(0);
  const [taskPriority, setTaskPriority] = useState("");
  const [taskStatusDefualt, setTaskStatusDefualt] = useState("");
const [assigneeLoading, setAssigneeLoading] = useState(false);
const [copyToLoading, setCopyToLoading] = useState(false);
const [progressLoading, setProgressLoading] = useState(false);
  async function getTask() {
    await axiosInstance
      .get(`/tasks/${alltasksViewId}`)
      .then(async (res) => {
        (await res?.data?.data) && setData(res?.data?.data);
        (await res?.data?.data?.taskTeam) &&
          setTeamId(res.data?.data?.taskTeam);
        (await res?.data?.data?.priority) &&
          setTaskPriority(res?.data?.data?.priority);
        (await res?.data?.data?.taskStatus) &&
          setTaskStatusDefualt(res?.data?.data?.taskStatus);
        (await res?.data?.data?.taskCompletion) &&
          setTaskProgressDefualt(res?.data?.data?.taskCompletion);

        let data = res.data.data;
        res.data.data &&
          setAssignee(
            data?.AssignedTo?.map((i) => {
              return i?.userId;
            })
          );
        res.data.data &&
          setCopyTo(
            data?.CopyTo?.map((i) => {
              return i?.userId;
            })
          );
        res.data.data &&
          setCreateNew({
            taskName: data?.taskName,
            taskTeam: data?.taskTeam,
            assignedTo:
              data?.AssignedTo?.map((i, k) => {
                return i?.userId;
              }) || [],
            copyTo:
              data?.CopyTo?.map((i, k) => {
                return i?.userId;
              }) || [],
            priority: data?.priority,
            severity: data?.severity,
            taskStatus: data?.taskStatus,
            revisedEndDate: data?.revisedEndDate || "None",
            reasonForDateRevised: data?.reasonForDateRevised,
            reAssignedTo: data?.reAssignedTo || [],
            comment: data?.comment,
            startDate: data?.startDate,
            endDate: data?.endDate,
            reminderDate: data?.reminderDate,
            reminderTime: data?.reminderTime,
            // attachment: data?.attachment,
            projectId: data?.projectId,
            titleId: data?.titleId,
            noOFWeeks: data?.noOFWeeks,
            noOFDays: data?.noOFDays,
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [taskProgressDefualt, setTaskProgressDefualt] = useState(0);

  const handleOpenProgressChange = (newOpen) => {
    setOpenProgress(newOpen);
  };

  const SubmitProgress = async (e) => {
  e.preventDefault();
  setProgressLoading(true);
  
  try {
    const completion = {
      taskCompletion: taskProgressDefualt,
    };

    const res = await axiosInstance.put(`/tasks/task-completion/${alltasksViewId}`, completion);
    
    if (res.status === 201 || res.data.status === true) {
      getTask();
      api.success({
        message: `Task updated successfully`,
        description: res.data.msg || "",
        placement: "bottomRight",
      });
      setOpenProgress(false);
    } else {
      api.error({
        message: `Task update failed`,
        description: res.data.msg || "Network error",
        placement: "bottomRight",
      });
    }
  } catch (err) {
    api.error({
      message: `Task update failed`,
      description: err.response?.data?.msg || "Network error",
      placement: "bottomRight",
    });
  } finally {
    setProgressLoading(false);
  }
};

  const [openProgress, setOpenProgress] = useState(false);
  function ChangeProgress() {
  return (
    <form onSubmit={SubmitProgress}>
      <div className="flex gap-2 items-start">
        <div className="w-[60%]">
          <Input
            type="number"
            value={taskProgressDefualt}
            onChange={handleChangeProgress}
            placeholder="0"
            max={100}
            min={0}
            disabled={progressLoading}
          />
        </div>
        <div className="w-[40%]">
          <Button
            htmlType="submit"
            className="text-black bg-mainColor-300 w-full"
            loading={progressLoading}
            disabled={progressLoading}
          >
            {progressLoading ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </div>
    </form>
  );
}

  const handleChangeProgress = (e) => {
    const inputValue = e.target.value;

    if (inputValue === "") {
      setTaskProgressDefualt("");
      return;
    }

    const numericValue = Number(inputValue);
    if (numericValue >= 0 && numericValue <= 100) {
      setTaskProgressDefualt(inputValue);
    }
  };

  const [assignee, setAssignee] = useState([]);
  const [copyTo, setCopyTo] = useState([]);
  const [openAssignee, setOpenAssignee] = useState(false);
  const [loadingAssignee, setLoadingAssignee] = useState(false);
  const [loadingCopyTo, setLoadingCopyTo] = useState(false);

  const [openCopy, setOpenCopy] = useState(false);
  const [availableUsers, setAvailableUsers] = useState([]);

  // Fetch users only once when component mounts
  // const { data: user } = UseDropDown(`/user/new-drop-down`);

  // useEffect(() => {
  //   if (user) {
  //     setAvailableUsers(user);
  //     // Initialize with current assignments
  //     setAssignee(data?.assignedTo?.map((user) => user.id) || []);
  //     setCopyTo(data?.copyTo?.map((user) => user.id) || []);
  //   }
  // }, [user, data]);


  const [teams, setTeams] = useState([]);

const getTeams = () => {
  axiosInstance
    .get(`/team/drop-down`)
    .then((res) => {
      if (Array.isArray(res.data)) {
        const formatted = res.data.map(item => ({
          value: item.value,
          label: item.label,
        }));
        setTeams(formatted);
      } else {
        setTeams([]);
        console.error("Unexpected API response format");
      }
    })
    .catch(err => {
      setTeams([]);
      console.error("Error fetching teams:", err);
    });
};

useEffect(() => {
  getTeams();
}, []);

 useEffect(() => {
    if (teams) {
      setAvailableUsers(teams);
      // Initialize with current assignments
      setAssignee(data?.assignedTo?.map((teams) => teams.id) || []);
      setCopyTo(data?.copyTo?.map((teams) => teams.id) || []);
    }
  }, [teams, data]);


  const handleOpenAssigneeChange = (newOpen) => {
    setOpenAssignee(newOpen);
  };

  const handleOpenCopyChange = (newOpen) => {
    setOpenCopy(newOpen);
  };

  const handleChangeAssignee = (value) => {
    setAssignee(value);
  };

  const handleChangeCopyTo = (value) => {
    setCopyTo(value);
  };

  const noOfDays = data?.noOfDays || 0;

  const fullWeeks = Math.floor(noOfDays / 7);
  const extraDays = noOfDays % 7;

  const noOfWeeksDisplay =
    noOfDays === 0
      ? "0"
      : fullWeeks === 0
      ? "1"
      : fullWeeks + (extraDays > 0 ? "+" : "");

 const SubmitAssignee = async (e) => {
  e.preventDefault();
  setAssigneeLoading(true);
  
  try {
    const payload = { ids: assignee };
    const res = await axiosInstance.put(`/tasks/assign-task/${alltasksViewId}`, payload);

    if (res.status === 201 || res.data.status === true) {
      const updatedAssignedTo = availableUsers
        .filter((user) => assignee.includes(user.value))
        .map((user) => ({ id: user.value, name: user.label }));

      setData((prev) => ({
        ...prev,
        assignedTo: updatedAssignedTo,
      }));

      api.success({
        message: "Assigned users updated successfully",
        placement: "bottomRight",
      });
      setOpenAssignee(false);
    }
  } catch (err) {
    api.error({
      message: "Update failed",
      description: err.response?.data?.msg || "Network error",
      placement: "bottomRight",
    });
  } finally {
    setAssigneeLoading(false);
  }
};

  const SubmitCopyto = async (e) => {
  e.preventDefault();
  setCopyToLoading(true);
  
  try {
    const payload = { ids: copyTo };
    const res = await axiosInstance.put(`/tasks/copy-task/${alltasksViewId}`, payload);

    if (res.status === 201 || res.data.status === true) {
      const updatedCopyTo = availableUsers
        .filter((user) => copyTo.includes(user.value))
        .map((user) => ({ id: user.value, name: user.label }));

      setData((prev) => ({
        ...prev,
        copyTo: updatedCopyTo,
      }));

      api.success({
        message: "Copy recipients updated successfully",
        placement: "bottomRight",
      });
      setOpenCopy(false);
    }
  } catch (err) {
    api.error({
      message: "Update failed",
      description: err.response?.data?.msg || "Network error",
      placement: "bottomRight",
    });
  } finally {
    setCopyToLoading(false);
  }
};

 function ChangeAssigee() {
  return (
    <form onSubmit={SubmitAssignee}>
      <div className="flex gap-2 items-start">
        <div className="w-[70%]">
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            options={teams}
            value={assignee}
            onChange={handleChangeAssignee}
            placeholder="Select assignees"
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            disabled={assigneeLoading}
          />
        </div>
        <div className="w-[30%]">
            <SubmitButton
  isLoading={assigneeLoading}
  name="Submit"
/>
          {/* <Button
            htmlType="submit"
            className="text-red-500  w-full hover:outline hover:outline-2 hover:outline-red-500 hover:text-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
            loading={assigneeLoading}
            disabled={assigneeLoading}
          >
            {assigneeLoading ? "..." : "Submit"}
          </Button> */}
        </div>
      </div>
    </form>
  );
}

function ChangeCopyTo() {
  return (
    <form onSubmit={SubmitCopyto}>
      <div className="flex gap-2 items-start">
        <div className="w-[70%]">
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            options={teams}
            value={copyTo}
            onChange={handleChangeCopyTo}
            placeholder="Select recipients"
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            disabled={copyToLoading}
          />
        </div>
        <div className="w-[30%]">
            <SubmitButton
  isLoading={copyToLoading}
  name="Submit"
/>
          {/* <Button
            htmlType="submit"
            className="text-red-500  w-full hover:outline hover:outline-2 hover:outline-red-500 hover:text-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
            loading={copyToLoading}
            disabled={copyToLoading}
          >
            {copyToLoading ? "..." : "Submit"}
          </Button> */}
        </div>
      </div>
    </form>
  );
}


  function DateDiffWithZero(createDate) {
    let exp = new Date();
    let cre = new Date(createDate);
    let timeDiff = Math.abs(exp.getTime() - cre.getTime());
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    console.log("time", diffDays);
    return diffDays;
  }
  function NowTime(time) {
    let finalDate = DateDiffWithZero(time);
    let finalTime = `${time}+0530`;

    if (finalDate > 1) {
      return <NuDate value={time} format="DD-MMM-YYYY" />;
    } else {
      // return moment(finalTime).fromNow();
      return <NuDate value={time} format="DD-MMM-YYYY , h:mm A" />;
    }
  }
  const [comment, setComment] = useState([]);

  const handleChangeImg = (e) => {
    const maxFileSize = 200000000; // 200 MB
    let fileArr = [];
    let previewArr = [];

    if (e.target.files.length > 0) {
      const files = Array.from(e.target.files);
      files.forEach((item) => {
        if (item.size < maxFileSize) {
          fileArr.push(item);
          previewArr.push(URL.createObjectURL(item));
        } else {
          api.warning({
            message: `File Size too big`,
            description: `${item.name} is Removed and not Uploaded`,
            placement: "bottomRight",
          });
        }
      });
      setSelectedFile(fileArr);
      setImage(previewArr);
    }
  };
  async function getComments() {
    await axiosInstance
      .get(`/task-comments/by-task/${alltasksViewId}`)
      .then(async (res) => {
        console.log("bbb", res?.data?.data);
        (await res?.data?.data) && setComment(res?.data?.data);
        // (await res?.data?.data?.image) && setImageList(res?.data?.data?.image);
        // (await res?.data?.data) && setStartDate(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    getComments();
  }, []);
  const userDetails = DecryptData("sLiAtEdReSuEdArT") || "";

  const loginId = userDetails?.id;
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
  const [createNewComment, setCreateNewComment] = useState({
    // clientTicketId: clientTickViewId,
    mainId: alltasksViewId,

    comments: "",
    files: "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNewComment,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      comments: yup.string().required("Enter the Comment "),
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(value));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      axiosInstance
        .post("/task-comments/new-comment", formData)
        .then((res) => {
          if (res.status === 201 || res.data.status == true) {
            // console.log(res);
            resetForm();
            setSelectedFile([]);
            setImage([]);
            getComments();
            //   onCancel();
            api.success({
              message: `Comment Display successfully`,
              // description:'',
              placement: "bottomRight",
            });
          } else {
            api.error({
              message: `Comment Display failed`,
              description: res.data.msg | "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Comment Display failed`,
            description: err?.response?.data.msg | "Network error",
            placement: "bottomRight",
          });
        });
    },
  });

  function formatTime(time) {
    if (!time || time === "None") return "-";
    const [hour, minute] = time.split(":");
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }
  console.log(data?.copyTo?.name, "copyto", data?.assignedTo?.name, "ass");
  const [filePathList, setFilePathList] = useState([]);

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="sm:flex justify-between mb-4">
        <Breadcrumb
          items={[
            {
              name: "All Task",
              link: "/tasks/all-tasks",
            },

            { name: "View" },
          ]}
        />
        <div className=" flex gap-2 justify-end">
          <Link
            to={`/tasks/all-tasks`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton />
          </Link>
          {/* <CreateButton svg={false} handleClick={downloadPDF} label="Download as PDF" /> */}
          {GetAccess("tasks_edit") && (
            <Link
              to={`/tasks/all-tasks/edit/${alltasksViewId}`}
              state={{
                data: data,
                from: `/tasks/all-tasks/view/${alltasksViewId}`,
              }}
            >
              <EditButton height="8" />
            </Link>
          )}
        </div>
      </div>
      <div className="w-full mx-auto h-[calc(100vh-145px)]   md:flex gap-2 text-[#111537] rounded-lg mt-0.5">
        <div className="md:w-[70%]  bg-white rounded-md drop-shadow-lg py-1 overflow-hidden ">
          <div className="sm:w-[98%] bg-white px-2 mx-2 border border-gray py-2  rounded-lg sm:flex justify-between items-center z-10">
            <div className="flex-1">
              <div className="flex ">
                <p className="font-semibold text-[13px] text-[#6B6868]">
                  {data?.refNo || "Ref"}
                </p>
                {/* <svg
        width="12"
        height="15"
        viewBox="0 0 12 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mt-0.5 hidden md:block"
      >
        <path
          d="M7.39038 1.58728H3.89038C2.23353 1.58728 0.890381 2.93043 0.890381 4.58728V10.5873C0.890381 12.2441 2.23353 13.5873 3.89038 13.5873H7.89038C9.54723 13.5873 10.8904 12.2441 10.8904 10.5873V5.08728M7.39038 1.58728H7.76906C8.16689 1.58728 8.54842 1.74532 8.82972 2.02662L10.451 3.64794C10.7323 3.92924 10.8904 4.31078 10.8904 4.7086V5.08728M7.39038 1.58728V3.58728C7.39038 4.41571 8.06195 5.08728 8.89038 5.08728H10.8904M2.89038 6.58728H5.89038M2.89038 8.58728H8.64038"
          stroke="#119DEE"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg> */}
                <p className="text-[#2A475E] text-[13px] font-semibold line-clamp-5">
                  : {data?.taskDesc || "No Desc"}
                </p>
              </div>
              <div className="flex text-sm mt-2">
                <p className="text-[13px] gap-2 flex text-[#111537] sm:w-[25%] ">
                  <User2 size={14} /> {data?.createdByName || "-"}
                </p>
                {/* <div className="flex  text-xs gap-2 text-[#111537] ">
               <CalendarDays size={14} className="text-gray-500 shrink-0" />
                   {data?.createdAt ? (
                       <NuDate value={data?.createdAt} format="DD-MMM-YYYY , hh:mm a"  /> 
                       
                     ) : (
                       "N/A"
                     )}        </div> */}
              </div>
              <div className="sm:flex flex-wrap gap-x-2 ">
                <p className="text-xs flex gap-2 text-[#111537] sm:w-[25%]">
                  <CalendarDays size={14} className="text-gray-500 shrink-0" />
                  {data?.createdAt ? (
                    <NuDate
                      value={data?.createdAt}
                      format="DD-MMM-YYYY , hh:mm a"
                    />
                  ) : (
                    "N/A"
                  )}
                </p>
                <div className="flex sm:w-[35%] flex-wrap gap-0.5 mt-3 sm:mt-0">
                  <p className="text-xs text-[#111537]">Assign. to:</p>
                  <p className="">
                    <Popover
                      content={<ChangeAssigee />}
                      overlayStyle={{ width: "25vw" }}
                      open={openAssignee}
                      placement="bottom"
                      title="Change or Re-assign"
                      trigger="click"
                      onOpenChange={handleOpenAssigneeChange}
                    >
                      <div className="w-full flex justify-start items-center gap-1 cursor-pointer rounded-md h-4 text-xs">
                        <NuAvatarGroupWithOutLink
                          link={true}
                          userdetails={data?.assignedTo || []}
                        />
                        <DownArrow />
                      </div>
                    </Popover>
                  </p>
                </div>

                <div className="flex sm:w-[35%] flex-wrap gap-0.5 mt-4 sm:mt-0">
                  <p className="text-xs text-[#111537] ">Copy to:</p>
                  <p className="">
                    <Popover
                      content={<ChangeCopyTo />}
                      overlayStyle={{ width: "25vw" }}
                      open={openCopy}
                      placement="bottom"
                      title="Change or Re-assign"
                      trigger="click"
                      onOpenChange={handleOpenCopyChange}
                    >
                      <div className="w-full flex justify-start items-center gap-1 p-[1px] rounded-md h-4 cursor-pointer text-xs">
                        <NuAvatarGroupWithOutLink
                          link={true}
                          userdetails={data?.copyTo || []}
                        />
                        <DownArrow />
                      </div>
                    </Popover>
                  </p>
                </div>
              </div>
            </div>

            <div className="sm:w-[130px] flex-shrink-0 mt-2 sm:mt-0 sm:border-l">
              <div className="flex flex-col items-center">
                <p className="text-[11px] 2xl:text-xs font-medium text-[#171A21] pb-1">
                  Progress
                </p>
                <Popover
                  content={<ChangeProgress />}
                  // overlayStyle={{ width: "15vw" }}
                  placement="bottom"
                  title="Update Progress"
                  trigger="click"
                  open={openProgress}
                  onOpenChange={handleOpenProgressChange}
                >
                  <div
                    className="cursor-pointer flex justify-center gap-2 items-center rounded-md text-[#444546] text-xs font-normal"
                    onClick={() => setOpenProgress(true)} // open on click
                  >
                    <Progress
                      type="circle"
                      size={45}
                      strokeWidth={12}
                      percent={Math.floor(data?.taskCompletion) || 0}
                      format={(percent) => (
                        <p
                          className={`${
                            percent > 95
                              ? "text-[#87d068]"
                              : percent > 50
                              ? "text-[#108ee9]"
                              : "text-[#D2BD00]"
                          } text-xs font-semibold`}
                        >
                          {percent}
                        </p>
                      )}
                      strokeColor={
                        data?.taskCompletion > 95
                          ? { "0%": "#87d068", "100%": "#87d068" }
                          : data?.taskCompletion > 50
                          ? { "0%": "#108ee9", "100%": "#108ee9" }
                          : { "0%": "#D2BD00", "100%": "#D2BD00" }
                      }
                    />
                    <DownArrow />
                  </div>
                </Popover>
              </div>
            </div>
          </div>

          <div className="mt-1">
            <div>
              <div className="h-[calc(100vh-360px)] overflow-y-auto pr-2 ">
                {comment?.map((data, idx) => (
                  <div key={idx} className="pb-4 ">
                    <div className="flex items-start gap-3">
                      {/* Avatar */}
                      <div className="w-8 h-8 rounded-full bg-mainColor-600 text-white font-medium flex items-center justify-center capitalize">
                        {data?.userName?.charAt(0)}
                      </div>
                      {/* Info + Action */}
                      <div className="flex flex-col flex-grow">
                        <div className="flex items-center gap-2">
                          <p className="font-semibold text-xs text-[#707884]">
                            {data?.userName} {"on"}
                          </p>
                          <p className="text-[#111537] text-xs font-normal">
                            {NowTime(data?.createdAt)}
                          </p>
                          {data?.userId === loginId && (
                            <EditComments
                              mainId={alltasksViewId}
                              data={data}
                              getData={getComments}
                            />
                          )}
                        </div>

                        {/* Comment Text */}
                        <p className="text-xs text-[#707884] font-medium mt-1">
                          {data?.comments}
                        </p>

                        {/* Images */}
                        {data?.attachments?.length > 0 && (
                          <div className="flex flex-wrap gap-2 mt-2">
                            {data?.attachments.map((attachment, idx) => (
                              <ViewFiles data={attachment} key={idx} />
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* <div className="w-full h-0.5 bg-[#F3F7FF] " /> */}

              {/* Comment Input Form */}
              <form onSubmit={formik.handleSubmit}>
                <div
                  className="flex flex-col md:flex-row mt-12 items-center gap-2 md:gap-4 w-full border-t border-[#EAEBED] p-2 md:p-1"
                  // style={{ boxShadow: '0 -2px 6px rgba(0, 0, 0, 0.1)' }}
                >
                  {" "}
                  <NuInput
                    type="text"
                    placeholder="Write a comment..."
                    formik={formik}
                    name="comments"
                    width="w-full"
                  />
                  <div className="flex items-center justify-end gap-2 md:w-2/12">
                    <div className=" flex items-center gap-1">
                      {image &&
                        image.map((item, idx) => {
                          return (
                            <div
                              className=" w-10 h-6 border rounded-md overflow-hidden"
                              key={idx}
                            >
                              <img src={item} alt="#" />
                            </div>
                          );
                        })}
                    </div>
                    <CustomAttachmentUpload
                      handleChange={handleChangeImg}
                      width=""
                      multiple={true}
                    />
                    <button type="submit" className="bg-white border-none">
                      <div className="w-8 h-8 rounded-full p-2 bg-baseColor-primary flex justify-center items-center">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 16 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.00106 13.5325C1.71412 13.6472 1.44152 13.622 1.18327 13.4567C0.925023 13.2914 0.795898 13.0513 0.795898 12.7362V9.52959C0.795898 9.32873 0.853287 9.14939 0.968065 8.99157C1.08284 8.83375 1.24066 8.73332 1.44152 8.69028L7.68256 7.14078L1.44152 5.59128C1.24066 5.54824 1.08284 5.44781 0.968065 5.28999C0.853287 5.13217 0.795898 4.95283 0.795898 4.75197V1.54537C0.795898 1.22973 0.925023 0.989273 1.18327 0.823993C1.44152 0.658713 1.71412 0.633749 2.00106 0.7491L15.2579 6.34451C15.6166 6.50233 15.7959 6.76775 15.7959 7.14078C15.7959 7.51381 15.6166 7.77923 15.2579 7.93705L2.00106 13.5325Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="md:w-[30%] mt-2 md:mt-0 bg-white rounded-lg drop-shadow-lg py-1">
          <div className="h-[98%] overflow-y-scroll p-2 ">
            <div className="flex gap-2 justify-between flex-wrap">
              <div className="inline-flex border border-[#6B43C6] rounded-full text-xs overflow-hidden">
                <span className="bg-white text-black px-2 py-1 font-medium">
                  Priority
                </span>
                <span className="bg-[#6B43C6] text-white px-2 py-1 font-medium">
                  {data?.priority || "None"}
                </span>
              </div>
              <div className=" flex items-center  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                <div className="  p-2 h-6  bg-white rounded-s-full text-xs flex items-center border border-baseColor-primary">
                  Status{" "}
                </div>
                <div className="  p-2 h-6  bg-textColor-main text-white text-xs rounded-e-full flex items-center">
                  {data?.taskStatus || "-"}
                </div>
              </div>
            </div>

            <div className="w-full grid  border border-gary mt-4  rounded-lg overflow-hidden">
              {/* <p className="text-xs text-[#111537] font-medium">Outgoing Detail</p> */}
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Schedule</p>
              </div>

              <div className=" w-full px-2">
                <table className=" w-full border-collapse text-left">
                  {/* <TempTrCom label="Status" value={data?.taskStatus||""} />                  
                  
                     <TempTrCom label="Priority" value={data?.priority||""} /> */}
                  <TempTrCom
                    label="Start Date"
                    value={
                      data?.startDate ? (
                        <NuDate value={data?.startDate} format="DD-MMM-YYYY" />
                      ) : (
                        ""
                      )
                    }
                  />

                  <TempTrCom
                    label="End Date"
                    value={
                      data?.endDate ? (
                        <NuDate value={data?.endDate} format="DD-MMM-YYYY" />
                      ) : (
                        ""
                      )
                    }
                  />

                  <TempTrCom label="No. of Week(s)" value={noOfWeeksDisplay} />
                  <TempTrCom label="No. of Day(s)" value={noOfDays} />

                  <TempTrCom
                    label="Reminder Date"
                    value={
                      data?.reminderDate ? (
                        <NuDate
                          value={data?.reminderDate}
                          format="DD-MMM-YYYY"
                        />
                      ) : (
                        ""
                      )
                    }
                  />
                  <TempTrCom
                    label="Reminder Time"
                    value={formatTime(data?.reminderTime)}
                  />
                </table>
              </div>
            </div>
            {/* <div className="flex gap-4 mt-4 p-2">

<div className="sm:w-[50%] w-full ">
    <p className=" p-2 text-xs font-medium text-[#111537]">
      Attachments
    </p>
    <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
      
      <div className="w-full flex gap-2 flex-wrap ">
        {data?.attachment &&
          data?.attachment.map((imgs, idx) => {
            console.log("img", imgs);
            return (
              <FilesView fileView={imgs} key={idx} />
            );
          })}
      </div>
    </div>
  </div>
</div> */}
            <div className="w-full grid  border border-gary  mt-4 rounded-lg overflow-hidden ">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Scope</p>
              </div>

              <div className="w-full px-2 h-24 overflow-y-scroll">
                <p className="text-xs">{data?.scopeOfWork}</p>
              </div>
            </div>
            <div className="w-full grid  border border-gary  mt-4 rounded-lg overflow-hidden ">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Attachments</p>
              </div>

              <div className="w-full px-2 h-24">
                <div className="  overflow-y-scroll h-28 rounded-lg p-2">
                  <div className="w-full flex gap-2 flex-wrap ">
                    {data?.attachment &&
                      data?.attachment.map((imgs, idx) => {
                        console.log("img", imgs);
                        return <FilesView fileView={imgs} key={idx} />;
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewnewTask;

function TempTrCom({ label = "", value = "" }) {
  return (
    <tr className="w-full">
      <td className="w-[50%]">
        <p className="py-2 text-xs font-medium text-[#111537]">{label}</p>
      </td>
      {/* <td className=""></td> */}
      <td className="flex-1 py-2 pl-0.5 w-[50%]">
        <p className="text-xs text-[#606279] truncate text-wrap">: {value}</p>
      </td>
    </tr>
  );
}
